import styled, { css } from 'styled-components';

const textPrimary = (p) => p.theme.colors.text.primaryText;
const textSecondary = (p) => p.theme.colors.text.secondaryText;
const borderColor = (p) => p.theme.colors.greys.defaultBorder || '#E0E0E0';
const errorColor = (p) => p.theme.colors.feedback.error || '#D32F2F';
const brandBlue = (p) => p.theme.colors.brand.blueOmint;
const disabledGrey = (p) => p.theme.colors.greys.disabledGrey;
const backgroundBlue = (p) => p.theme.colors.brand.backgroundBlue;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: ${(props) => props.$mb || '0px'};
  max-width: auto;
  position: relative;
  width: ${(props) => props.fullWidth ? '100%' : 'auto'};
 
`;

export const Label = styled.label`
  display: flex;
  font-size: 16px;
  font-weight: 500;
  color: ${textPrimary};
`;

export const InputContainer = styled.div`
  position: relative;
  width: ${(props) => props.width || '100%'};
  max-width: ${(props) => props.width|| '359px'};
  min-width: ${(props) =>props.width || '259px'};

  @media (max-width: 768px) {
    width: 100%;
    max-width:  ${(props) => props.width|| '598px'};
    min-width:  ${(props) => props.width|| '200px'}; ;
  }
`;
  
const BaseInputStyle = css`
  width: ${(props) => props.width || '100%'};
  max-width: ${(props) => props.width|| '359px'};
  min-width: ${(props) =>props.width || '259px'};
  height: ${(props) => (props.$isTextArea ? '140px' : '40px')};
  padding: 8px 16px;
  padding-left: ${(props) => (props.$hasLeft ? '40px' : '16px')};
  padding-right: ${(props) => (props.$hasRight ? '40px' : '16px')};
  border: 1px solid
    ${(props) => (props.$error ? errorColor(props) : borderColor(props))};
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  background-color: ${(props) =>
    props.disabled ? backgroundBlue(props) : 'white'};
  color: ${(props) =>
    props.disabled ? borderColor(props) : textPrimary(props)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'text')};
  box-sizing: border-box;
  resize: ${(props) => (props.$isTextArea ? 'vertical' : 'none')};

  &::placeholder {
    color: ${disabledGrey};
  }

  &:focus {
    border-color: ${brandBlue};
    box-shadow: 0 0 0 1px ${brandBlue}33;
  }

  &:disabled {
    opacity: 0.6;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const StyledInput = styled.input`
  ${BaseInputStyle};
`;

export const TextAreaContent = styled.textarea`
  ${BaseInputStyle};
  height: 140px;

  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    width: 100%;
  }
`

export const ErrorMessage = styled.span`
  display: block;
  font-size: 14px;
  color: ${errorColor};
`;

export const HelperText = styled.span`
  display: block;
  font-size: 14px;
  color: #6b7280;
`;

const iconBase = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const InputIconLeft = styled.div`
  ${iconBase};
  left: 12px;
  color: ${textSecondary};
`;

export const InputIconRight = styled.div`
  ${iconBase};
  right: 12px;
  color: ${textSecondary};
`;

export const IconInputPassword = styled.div`
  ${iconBase};
  right: 12px;
  color: ${textSecondary};
  cursor: pointer;

  > div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    display: block;
    width: 20px;
    height: 20px;
  }
`;